import { imageUrl } from 'app/frontend/base/helpers'
import { NOTE_ICON_URL } from '../config/generalAbilities'
import { formatTimelineTimestamp } from './timelineMath'

type TimelineHoverCastPreviewProps = {
  hoverTime: number
  hoveredRowIndex: number
  rowsTop: number
  rowHeight: number
  rowGap: number
  iconSize: number
  iconInset: number
  opacity?: number
  toX: (time: number) => number
  getRowSpellId: (rowIndex: number) => number | null | undefined
  getRowHeatmapValue?: (rowIndex: number, time: number) => number | null
}

const TimelineHoverCastPreview = ({
  hoverTime,
  hoveredRowIndex,
  rowsTop,
  rowHeight,
  rowGap,
  iconSize,
  iconInset,
  opacity = 0.7,
  toX,
  getRowSpellId,
  getRowHeatmapValue,
}: TimelineHoverCastPreviewProps) => {
  const spellId = getRowSpellId(hoveredRowIndex)
  if (spellId === undefined) return null
  const previewX = toX(hoverTime)
  const previewY = rowsTop + hoveredRowIndex * (rowHeight + rowGap)
  const previewLabel = formatTimelineTimestamp(hoverTime)
  const heatmapValue = getRowHeatmapValue?.(hoveredRowIndex, hoverTime)
  const heatmapLabel =
    typeof heatmapValue === 'number' && heatmapValue > 0
      ? ` · ${Math.round(heatmapValue * 100)}%`
      : null

  return (
    <g className='pointer-events-none'>
      <image
        x={previewX + iconInset}
        y={previewY + iconInset}
        width={iconSize - iconInset * 2}
        height={iconSize - iconInset * 2}
        href={
          spellId === null ? NOTE_ICON_URL : imageUrl(`icons/${spellId}.jpg`)
        }
        preserveAspectRatio='xMidYMid slice'
        opacity={opacity}
      />
      <rect
        x={previewX}
        y={previewY}
        width={iconSize}
        height={iconSize}
        fill='transparent'
        opacity={opacity}
      />
      <g className='text-accent-foreground' opacity={opacity}>
        <text
          x={previewX + iconSize + 3}
          y={previewY + 1 + rowHeight / 2}
          fill='currentColor'
          fontSize={12}
          dominantBaseline='middle'
        >
          {previewLabel}
          {heatmapLabel ? (
            <tspan fill='var(--color-muted-foreground)'>{heatmapLabel}</tspan>
          ) : null}
        </text>
      </g>
    </g>
  )
}

export default TimelineHoverCastPreview
